// Default placeholder images
export const DEFAULT_EMPLOYEE_PHOTO = "data:image/svg+xml;utf8," + encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>
    <rect width='100' height='100' fill='#0067b2'/>
    <circle cx='50' cy='38' r='18' fill='#fff'/>
    <path d='M20 95c0-18 13-30 30-30s30 12 30 30' fill='#fff'/>
  </svg>`
);

export const DEFAULT_ITEM_PHOTO = "data:image/svg+xml;utf8," + encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>
    <rect width='100' height='100' fill='#e6f0f8'/>
    <path d='M25 30 L75 30 L75 78 L25 78 Z' fill='none' stroke='#0067b2' stroke-width='3'/>
    <path d='M25 30 L50 18 L75 30' fill='none' stroke='#0067b2' stroke-width='3'/>
    <text x='50' y='62' text-anchor='middle' fill='#0067b2' font-size='10' font-family='Arial' font-weight='bold'>DPI</text>
  </svg>`
);

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Le foto sono pubbliche per progetto: compaiono sulle pagine QR di tesserini,
// mezzi e articoli, che si aprono senza login.
export const photoUrl = (path) => path ? `${BACKEND_URL}/api${path}` : null;

// I documenti invece sono protetti. Un tag <a> o <img> non puo' inviare
// l'intestazione Authorization, quindi il token viaggia in coda all'indirizzo:
// senza, il server risponde 401 e il file non si scarica.
export const fileUrl = (path) => {
  if (!path) return null;
  const token = localStorage.getItem("sgm_token");
  const url = `${BACKEND_URL}/api${path}`;
  return token ? `${url}?token=${encodeURIComponent(token)}` : url;
};
